import { articles } from '@/mocks/articles';

export const SITE_NAME = 'CSSBuyBR.TOP';
export const FAVICON_URL =
  'https://static.readdy.ai/image/2df560051ef0cafd8dabf8a049058ba4/d367cf6745ee47f3fc82c76d3a54c50c.png';

export const SITE_DEFAULT_LOCALE = 'pt_BR';

/**
 * Returns the real site origin. Prefers the VITE_SITE_URL environment variable,
 * falling back to the browser origin when it is not available.
 */
export function getSiteOrigin(): string {
  const fromEnv = import.meta.env.VITE_SITE_URL as string | undefined;
  const origin =
    typeof fromEnv === 'string' && fromEnv.length > 0
      ? fromEnv
      : typeof window !== 'undefined'
        ? window.location.origin
        : '';
  return origin.replace(/\/+$/, '');
}

export interface RouteSEO {
  /** Document title */
  title: string;
  /** Meta description */
  description: string;
  /** Comma-separated keywords */
  keywords: string;
  /** Canonical path (starts with "/") */
  path: string;
  /** Open Graph type */
  type: 'website' | 'article';
}

const staticRoutes: Record<string, RouteSEO> = {
  '/': {
    title: 'CSSBuy Spreadsheet 2026 — Encontre, Compare e Organize Produtos CSSBuy',
    description:
      'CSSBuy Spreadsheet: Encontre planilhas, produtos, categorias e guias CSSBuy em um só lugar. Recurso independente em Português, English e Deutsch.',
    keywords:
      'CSSBuy Spreadsheet, CSSBuy Spreadsheet 2026, CSSBuy Review, CSSBuy Shipping Cost, CSSBuy Coupon, planilha CSSBuy',
    path: '/',
    type: 'website',
  },
  '/products/': {
    title: 'CSSBuy Products — Browse All Categories & Buy Now | CSSBuyBR.TOP',
    description:
      'Explore all CSSBuy product categories — shoes, hoodies, t-shirts, jackets, bags, accessories and more. Find organized links and buy directly from the main site.',
    keywords:
      'CSSBuy products, CSSBuy categories, CSSBuy shoes, CSSBuy hoodies, CSSBuy accessories, buy CSSBuy',
    path: '/products/',
    type: 'website',
  },
  '/cssbuy-spreadsheet/': {
    title: 'CSSBuy Spreadsheet — Complete 2026 Guide | CSSBuyBR.TOP',
    description:
      'CSSBuy Spreadsheet complete guide. Learn what a CSSBuy spreadsheet is, how to use it, find products, check QC and understand shipping in 2026.',
    keywords:
      'CSSBuy Spreadsheet, CSSBuy Spreadsheet 2026, CSSBuy Spreadsheet Guide, CSSBuy W2C Spreadsheet, CSSBuy Product Spreadsheet',
    path: '/cssbuy-spreadsheet/',
    type: 'website',
  },
  '/cssbuy-review/': {
    title: 'CSSBuy Review: What You Need to Know Before Buying | CSSBuyBR.TOP',
    description:
      'CSSBuy Review covering features, pros, cons, warehouse, QC, shipping, payment and safety. An independent look at the CSSBuy experience.',
    keywords:
      'CSSBuy Review, CSSBuy reviews, CSSBuy experience, CSSBuy agent review, is CSSBuy good',
    path: '/cssbuy-review/',
    type: 'website',
  },
  '/cssbuy-shipping-cost/': {
    title: 'CSSBuy Shipping Cost: Understand International Shipping | CSSBuyBR.TOP',
    description:
      'CSSBuy Shipping Cost guide. Understand how shipping prices are calculated by weight, volume, destination, method and insurance before you order.',
    keywords:
      'CSSBuy Shipping Cost, CSSBuy shipping calculator, CSSBuy shipping rates, CSSBuy shipping price',
    path: '/cssbuy-shipping-cost/',
    type: 'website',
  },
  '/cssbuy-coupon/': {
    title: 'CSSBuy Coupon: How to Find and Verify Discounts | CSSBuyBR.TOP',
    description:
      'CSSBuy Coupon guide. Learn how coupons work, where to verify current offers, restrictions, expiration and how to avoid fake discount codes.',
    keywords:
      'CSSBuy Coupon, CSSBuy coupon code, CSSBuy promo, CSSBuy discount code, CSSBuy promo code',
    path: '/cssbuy-coupon/',
    type: 'website',
  },
  '/cssbuy-warehouse/': {
    title: 'CSSBuy Warehouse: Storage, QC and Parcel Guide | CSSBuyBR.TOP',
    description:
      'CSSBuy Warehouse guide covering storage, QC inspection, parcel preparation and international shipping. Understand how the warehouse process works.',
    keywords:
      'CSSBuy Warehouse, CSSBuy storage, CSSBuy QC, CSSBuy parcel, CSSBuy inspection',
    path: '/cssbuy-warehouse/',
    type: 'website',
  },
  '/cssbuy-legit/': {
    title: 'Is CSSBuy Legit? Safety, Trust and Buying Guide | CSSBuyBR.TOP',
    description:
      'Is CSSBuy Legit? A balanced safety and trust guide covering official URLs, account security, payment safety and how to avoid fake websites.',
    keywords:
      'CSSBuy Legit, is CSSBuy legit, CSSBuy safe, CSSBuy trustworthy, CSSBuy scam',
    path: '/cssbuy-legit/',
    type: 'website',
  },
  '/safety/': {
    title: 'CSSBuy Safety Center: Shop with More Security | CSSBuyBR.TOP',
    description:
      'CSSBuy Safety Center. Learn how to verify links, protect your account and avoid suspicious or fake websites while researching CSSBuy products.',
    keywords:
      'CSSBuy Safety, CSSBuy safe, CSSBuy scam protection, CSSBuy verify links, CSSBuy security',
    path: '/safety/',
    type: 'website',
  },
  '/faq/': {
    title: 'CSSBuy FAQ: Frequently Asked Questions | CSSBuyBR.TOP',
    description:
      'CSSBuy FAQ answering common questions about spreadsheets, W2C, QC photos, shipping costs, coupons, warehouse and account safety.',
    keywords:
      'CSSBuy FAQ, CSSBuy questions, CSSBuy W2C, CSSBuy QC photos, CSSBuy shipping',
    path: '/faq/',
    type: 'website',
  },
  '/about/': {
    title: 'About CSSBuyBR.TOP — Independent CSSBuy Spreadsheet Resource',
    description:
      'About CSSBuyBR.TOP, an independent CSSBuy Spreadsheet resource center. Learn about our mission, authors and editorial policy.',
    keywords: 'about CSSBuyBR, CSSBuy Spreadsheet resource, independent CSSBuy resource',
    path: '/about/',
    type: 'website',
  },
  '/contact/': {
    title: 'Contact CSSBuyBR.TOP | CSSBuyBR.TOP',
    description:
      'Contact CSSBuyBR.TOP. Get in touch with our team for questions, feedback and suggestions about the CSSBuy Spreadsheet resource center.',
    keywords: 'contact CSSBuyBR, CSSBuy contact, CSSBuy Spreadsheet support',
    path: '/contact/',
    type: 'website',
  },
  '/privacy-policy/': {
    title: 'Privacy Policy | CSSBuyBR.TOP',
    description:
      'Privacy Policy for CSSBuyBR.TOP. Learn how we collect, use and protect your information when you visit our CSSBuy Spreadsheet resource center.',
    keywords: 'CSSBuyBR privacy policy, CSSBuy privacy',
    path: '/privacy-policy/',
    type: 'website',
  },
  '/terms/': {
    title: 'Terms of Use | CSSBuyBR.TOP',
    description:
      'Terms of Use for CSSBuyBR.TOP. The rules and conditions that apply when using our CSSBuy Spreadsheet resource website.',
    keywords: 'CSSBuyBR terms of use, CSSBuy terms',
    path: '/terms/',
    type: 'website',
  },
  '/disclaimer/': {
    title: 'Disclaimer | CSSBuyBR.TOP',
    description:
      'Disclaimer — CSSBuyBR.TOP is an independent resource and is not affiliated with, sponsored by, or officially endorsed by CSSBuy.',
    keywords: 'CSSBuyBR disclaimer, CSSBuy independent resource, CSSBuy affiliate disclosure',
    path: '/disclaimer/',
    type: 'website',
  },
};

export function getRouteSEO(pathname: string): RouteSEO | null {
  const path = pathname || '/';

  if (path.startsWith('/article/')) {
    const slug = path.replace('/article/', '').replace(/\/+$/, '');
    const article = articles.find((a) => a.slug === slug);
    if (article) {
      return {
        title: article.metaTitle,
        description: article.metaDescription,
        keywords: article.keywords.join(', '),
        path: `/article/${article.slug}`,
        type: 'article',
      };
    }
    return null;
  }

  return staticRoutes[path] ?? staticRoutes[path.replace(/\/+$/, '')] ?? null;
}